import { render, staticRenderFns } from "./ManageAdd.vue?vue&type=template&id=32ce1189&lang=pug&"
import script from "./ManageAdd.vue?vue&type=script&lang=js&"
export * from "./ManageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ManageAdd.vue"
export default component.exports